import { Injectable } from '@angular/core';
import { WebSocketPacket } from '../../interfaces/all';
import { AuthService } from 'src/app/auth.service';

@Injectable({
	providedIn: 'root'
})
export class WsPacketService {
	constructor(private auth: AuthService) { }
    private transactionId = this.getRandomInt(100000, 200000);
	private itemId = this.getRandomInt(1000, 5000);

	getUid() {
		let navigator_info = window.navigator;
		let screen_info = window.screen;
		let uid: any = navigator_info.mimeTypes.length;
		uid += navigator_info.userAgent.replace(/\D+/g, '');
		uid += navigator_info.plugins.length;
		uid += screen_info.height || '';
		uid += screen_info.width || '';
		uid += screen_info.pixelDepth || '';
		return uid;
	}

	getRandomInt(min, max) {
		return Math.floor(Math.random() * (max - min + 1)) + min;
	}

	getCurrentId () {
		return this.auth.userDetail.user._id;
	}

	getAuthenticatePackets(): WebSocketPacket {
		this.transactionId += 1;
		this.itemId += 1;
		let packetTemplate: WebSocketPacket = {
			direction: 'request',
			operation: 'authenticate',
			class: 'user',
			senderId: this.getCurrentId() + '.datadashboard',
			items: [{
				itemId: this.itemId,
				payload: {
					token: this.auth.userDetail.tokens.access_token,
					clientDeviceId: 'datadashboard' + this.getUid()
				}
			}],
			transactionId: this.transactionId,
			version: 1
		};
		return packetTemplate;
	}

	getPacket(Class: string, operation: string, payload: object): WebSocketPacket {
		this.transactionId += 1;
		this.itemId += 1;

		let packetTemplate: WebSocketPacket = {
			direction: 'request',
			operation: operation,
			class: Class,
			senderId: this.auth.userDetail.user._id + '.datadashboard',
			items: [{
				itemId: this.itemId,
				payload: payload
			}],
			transactionId: this.transactionId,
			version: 1
		};

		return packetTemplate;
	}
}
